import {CommonActions} from '@react-navigation/native';
import {NavigationKey} from '../navigations/config';

let _navigator: any;

const setTopLevelNavigator = (navigatorRef: any) => {
  _navigator = navigatorRef;
};

/**
 * Navigate to a screen inside a specific stack.
 * Use this when you need to target a stack other than the consultation stack
 * (e.g. profile, notification, etc.).
 */
const navigateToStack = (stack: string, screen: string, params?: any) => {
  if (!_navigator) return;
  _navigator.dispatch(
    CommonActions.navigate(stack, {
      screen: screen,
      params: params,
    }),
  );
};

/**
 * Navigate to a screen inside the consultation stack.
 * Both PATIENT_CONSULTATION_STACK and DOCTOR_CONSULTATION_STACK resolve to 'consultation',
 * so React Navigation routes to the correct one based on the currently mounted drawer.
 */
const navigate = (screen: string, params: any) => {
  navigateToStack(NavigationKey.DOCTOR_CONSULTATION_STACK, screen, params);
};

/**
 * Navigate to a screen registered directly on the root navigator (not
 * nested inside a stack) - e.g. SHARED_DOCTOR_PROFILE.
 */
const navigateToRootScreen = (screen: string, params?: any) => {
  if (!_navigator) return;
  _navigator.dispatch(CommonActions.navigate(screen, params));
};

export {navigate, navigateToStack, navigateToRootScreen, setTopLevelNavigator};
